import type { RailwayBucketCredentials } from '@cli-types/next-adapter/railway.js'
import { isNonEmptyString } from '@cli-utils/shared.js'

export function parseBucketCredentials(value: unknown): RailwayBucketCredentials | undefined {
  if (!value || typeof value !== 'object') return undefined
  const credentials = value as Record<string, unknown>
  const keys = [
    'endpoint',
    'accessKeyId',
    'secretAccessKey',
    'bucketName',
    'region',
    'urlStyle'
  ] as const
  if (!keys.every((key) => isNonEmptyString(credentials[key]))) return undefined

  return {
    endpoint: credentials.endpoint as string,
    accessKeyId: credentials.accessKeyId as string,
    secretAccessKey: credentials.secretAccessKey as string,
    bucketName: credentials.bucketName as string,
    region: credentials.region as string,
    urlStyle: credentials.urlStyle as string
  }
}
